var _ellipse, _path, _ellipse2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChildWithAdult = function SvgIconChildWithAdult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.34795,
    cy: 10.7865,
    rx: 2.6087,
    ry: 2.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.1681C2 15.7669 3.94659 13.8203 6.34783 13.8203C8.74906 13.8203 10.6957 15.7669 10.6957 18.1681V22.6203H2V18.1681Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.1422,
    cy: 4.35353,
    rx: 2.87856,
    ry: 2.9131
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7949 12.8283C12.7949 10.4271 14.7415 8.48047 17.1427 8.48047C19.544 8.48047 21.4906 10.4271 21.4906 12.8283V22.5605H12.7949V12.8283Z"
  })));
};
export default SvgIconChildWithAdult;